var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',[_c('kt-panel',[_c('kt-panel-body',[_c('kt-row',{attrs:{"id":"pardakht-shakhsi-info"}},[_c('kt-col',{attrs:{"xs":"12","md":"6"}},[(_vm.status !== 'loading')?_c('ps-info',{attrs:{"form_data":_vm.form_data}}):_vm._e()],1),_c('kt-col',{attrs:{"xs":"12","md":"6","id":"setting_col"}},[_c('ps-setting')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }